import React, { useState } from "react";
import { Dropdown } from "react-bootstrap";
import PlusIcon from "../../../icons/plus.icon.jsx";
import styles from "./ManageViewDropdown.module.scss";
import headerStyles from "./MspAccountsHeader.module.scss";

const ManageViewDropdown = ({ filters = [], onFilterChange = () => {} }) => {
  const [selectedItem, setSelectedItem] = useState(null);

  const dropdownItems = [
    {
      id: "save-changes",
      label: "Save Changes",
      colorClass: headerStyles.dropdownItemLabelGray,
      onClick: () => handleItemClick("save-changes"),
    },
    {
      id: "rename",
      label: "Rename",
      colorClass: headerStyles.dropdownItemLabelGray,
      onClick: () => handleItemClick("rename"),
    },
    {
      id: "set-default",
      label: "Set as Default View",
      colorClass: headerStyles.dropdownItemLabelGray,
      onClick: () => handleItemClick("set-default"),
    },
    {
      id: "delete",
      label: "Delete",
      colorClass: headerStyles.dropdownItemLabelAlert,
      onClick: () => handleItemClick("delete"),
    },
    {
      id: "new-view",
      label: "New View",
      colorClass: headerStyles.dropdownItemLabelPrimary,
      icon: <PlusIcon className={headerStyles.dropdownItemIcon} fill="#008FD4" style={{ fill: "#008FD4" }} />,
      hasSeparator: true,
      onClick: () => handleItemClick("new-view"),
    },
  ];

  const handleItemClick = (itemId) => {
    setSelectedItem(itemId);
    // TODO: Implement actual handlers for each action
    console.log("Item clicked:", itemId);
  };

  return (
    <Dropdown className={styles.dropdown}>
      <Dropdown.Toggle as="div" className={styles.toggle}>
        <div
          className={styles.manageViewButton}
          aria-label="Manage view"
        >
          <span className={styles.manageViewText}>Manage View</span>

          <div className={styles.manageViewChevron}>
            <img
              src="/images/big-chevron-down.svg"
              alt=""
              className={styles.manageViewChevronIcon}
              width={6}
              height={6}
              style={{ filter: "brightness(0) saturate(100%) invert(45%) sepia(96%) saturate(2000%) hue-rotate(180deg) brightness(0.9) contrast(1.1)" }}
            />
          </div>
        </div>
      </Dropdown.Toggle>
      <Dropdown.Menu className={styles.menu}>
        <div
          className={headerStyles.dropdownMenu}
          role="menu"
          aria-label="Dropdown menu"
        >
          {dropdownItems.map((item) => (
            <button
              key={item.id}
              className={`${headerStyles.dropdownMenuItem} ${
                item.hasSeparator ? headerStyles.dropdownMenuItemWithSeparator : ""
              }`}
              role="menuitem"
              onClick={item.onClick}
              aria-label={item.label}
              tabIndex={0}
            >
              <div className={headerStyles.dropdownMenuItemInner}>
                {item.icon && (
                  <div className={headerStyles.dropdownMenuItemIconContainer}>
                    {item.icon}
                  </div>
                )}

                <div className={`${headerStyles.dropdownItemLabel} ${item.colorClass}`}>
                  {item.label}
                </div>
              </div>
            </button>
          ))}
        </div>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default ManageViewDropdown;

